import { createApp, watch } from 'vue';
import { storeToRefs } from 'pinia';
import useShopContentStore from '@global/stores/useShopContentStore';
import common from '@page/common/js/common';
import IndexTemplate from '@page/shopContent/template/index.pug';
import FoodTemplate from '@page/shopContent/template/food.pug';
import Photo from '@page/shopContent/components/ClothPhoto.vue';
import FoodPhoto from '@page/shopContent/components/FoodPhoto.vue';
import Spec from '@page/shopContent/components/SpecCloth.vue';
import SpecFood from '@page/shopContent/components/SpecFood.vue';
import SpecMobile from '@page/shopContent/components/SpecMobile.vue';
import SpecMobileFood from '@page/shopContent/components/SpecMobileFood.vue';
import StockMobile from '@page/shopContent/components/StockMobile.vue';
import Recommend from '@page/shopContent/components/Recommend.vue';
import BrandRecommend from '@page/shopContent/components/BrandRecommend.vue';
import Addon from '@page/shopContent/components/AddonShop.vue';
import NewImage from '@global/components/common/Image/NewImage.vue';
import BrandBtn from '@components/BrandBtn.vue';
import CartDialog from '@components/CartDialog.vue';
import FoodDialog from '@components/FoodDialog.vue';
import $ from 'jquery';
import { fireShopContentView } from '@global/gtm/product';
import { productInfoEnum } from '@/models/productEnum';

require('@global/vendors/jquery.sticky-kit');

const app = createApp({
  components: {
    Spec,
    SpecMobile,
    Photo,
    Recommend,
    BrandRecommend,
    Addon,
    NewImage,
    BrandBtn,
    SpecMobileFood,
    SpecFood,
    FoodPhoto,
    CartDialog,
    FoodDialog,
    StockMobile,
  },
  setup() {
    const category = window.ItemCategories[0];
    const levelTwo = window.ItemCategories[1];
    const { CustomMarketID } = window;
    const pattern = window.Pattern;

    const shopContentStore = useShopContentStore();

    const {
      itemDatas,
      selectedDataID,
      dataIsLoad,
      userSelectFlavor,
      selectedFoodSpec,
      CMID,
      selectedData,
      isOpenStockDialog,
    } = storeToRefs(shopContentStore);

    const { getData, getRecommendData, getSelectedData } = shopContentStore;

    getData(pattern);
    getRecommendData();

    function changeTab(event) {
      event.preventDefault();

      const target = $(event.target);
      const href = target.attr('href');
      const scrollTop = $(href).offset().top - 138;

      target.siblings().removeClass('active');
      target.addClass('active');

      window.scroll({
        top: scrollTop,
        behavior: 'smooth',
      });
    }

    watch(selectedDataID, () => {
      getSelectedData();

      fireShopContentView({
        customMarketID: window.CustomMarketID,
        name: itemDatas.value.Name,
        price: itemDatas.value.SellPrice,
        affiliation: selectedData.value.Name,
        eventName: itemDatas.value.Events?.length ? itemDatas.value.Events[0]?.Name : '',
      });
    });

    return {
      category,
      levelTwo,
      productInfoEnum,
      CustomMarketID,
      itemDatas,
      selectedDataID,
      dataIsLoad,
      userSelectFlavor,
      selectedFoodSpec,
      pattern,
      CMID,
      selectedData,
      changeTab,
      isOpenStockDialog,
    };
  },
  template: window.Pattern !== 2 ? IndexTemplate : FoodTemplate,
});

app.mount('#shop-content');

$('.product-menu-pc').stick_in_parent({ offset_top: 180 });
